import { motion } from "framer-motion";
import { MANIFESTO } from "../data/services";
import { Reveal, EASE } from "../components/site/Reveal";

export const Manifesto = () => (
  <section className="relative py-28 md:py-40 bg-[var(--bg2)] overflow-hidden" data-testid="manifesto-section">
    <div className="mx-auto max-w-6xl px-6">
      <Reveal>
        <p className="mono text-xs tracking-[0.4em] uppercase text-[var(--green)] mb-16">Nuestro Manifiesto</p>
      </Reveal>
      <div>
        {MANIFESTO.map((line, i) => (
          <motion.div
            key={line}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-90px" }}
            transition={{ duration: 0.9, ease: EASE }}
            className={`group flex items-baseline gap-6 md:gap-12 border-t border-[var(--line)] py-9 md:py-12 ${i === MANIFESTO.length - 1 ? "border-b" : ""} ${i % 2 === 1 ? "md:pl-24" : ""}`}
            data-testid={`manifesto-item-${i + 1}`}
          >
            <span className="mono shrink-0 text-4xl md:text-6xl font-medium text-transparent" style={{ WebkitTextStroke: "1px rgba(0,199,165,0.45)" }}>
              0{i + 1}
            </span>
            <h3 className="text-2xl md:text-4xl lg:text-5xl font-bold tracking-tight leading-tight text-[var(--ink)]/85 transition-colors duration-500 group-hover:text-[var(--ink)]">
              {line}
            </h3>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
